// 引入数据配置文件
import FormConfig from "./formConfig.js";
import { fun_PostAction } from "@/api/index";
// 引入加密方法
import "../../../../utils/security.js";
import {
  fun_LoadXSKeyInterface,
  fun_XSKeyFind,
  fun_XSKeyHID,
  fun_XSKeyAdminLogon,
  fun_XSKeyHmacMD5,
  fun_XSKeySetMd5Key,
  fun_XSKeySetAdminPassword,
  fun_XSKeyWriteData,
  fun_XSKeyReadData,
} from "../../../../utils/commonXsLock";
export default {
  data() {
    return {
      // 表单对象
      form: {
        ymm: null, // 原密码
        yhmm: null, // 新密码
        yhmmqr: null,  // 确认密码
        smm: null, // 锁密码
      },
      // 表单对象
      request: {
        exponent: null, // 加密exponent参数
        modulus: null, // 加密modulus参数
        ymm: null, // 原密码
        yhmm: null, // 新密码
        yhmmqr: null, // 确认密码
        smm: null, // 锁密码
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      key: null, // 加密key
      yhmc: null, // 用户名称
    };
  },
  // 模板编译完成
  mounted() {
    // 获取初始化参数接口
    this.fun_GetInit();
  },
  // 自定义方法
  methods: {
    /**
     * 获取初始化参数接口
     * @author 滕威
     */
    fun_GetInit() {
      // 调用获取加密参数接口
      fun_PostAction("/userPassword/init").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取exponent
          this.request.exponent = data.exponent;
          // 获取modulus
          this.request.modulus = data.modulus;
          // 获取用户名称
          this.yhmc = data.yhmc;
        }
      });
    },
    /**
     * @description 保存
     * @author
     */
    fun_Save() {
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        if (valid) {
          // 密保控件
          fun_LoadXSKeyInterface();
          // 硬件号
          let keyHID = fun_XSKeyHID();
          // 如果锁编号为空
          if (keyHID == "" || keyHID == null) {
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("密保锁读取失败");
            // 关闭loading
            this.loading = false;
            return;
          }
          // 获取加密key
          this.key = window.RSAUtils.getKeyPair(this.request.exponent, "", this.request.modulus);
          // 设置锁编号
          let serialNum = window.RSAUtils.encryptedString(this.key, keyHID);
          // 设置用户密码
          let yhmc = window.RSAUtils.encryptedString(this.key, this.yhmc);
          // 发起请求，获取结果集
          fun_PostAction("/userLogin/xsLogin", {
            username: yhmc,
            serialNum: serialNum
          }).then(res => {
            // 解构res.data
            const {
              result,
              data
            } = res.data;
            // 判断请求是否成功
            if (result) {
              // 锁管理员登录
              let msg = fun_XSKeyAdminLogon(data);
              // 存在错误的场合
              if (msg != '') {
                // 关闭loading
                this.loading = false;
                // 请求失败，提示信息
                this.$message.error(msg);
                return false;
              } else {
                // 锁内容读取
                let snr = fun_XSKeyReadData();
                // MD5密码
                let md5Password = fun_XSKeyHmacMD5(snr);
                // 设置锁密码
                this.form.smm = snr + ';' + md5Password;
                // 提交
                this.fun_Submit();
              }
            } else {
              // 关闭loading
              this.loading = false;
              // 请求失败，提示信息
              this.$message.error("密保锁认证失败！请插入对应的密保锁！");
              return false;
            }
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 提交
     */
    fun_Submit() {
      try {
        // 遍历加密用户名、密码、验证码
        for (let e in this.form) {
          this.request[e] = window.RSAUtils.encryptedString(this.key, this.form[e]);
        }
        // 打开loading
        this.loading = true;
        // 执行获取列表接口
        fun_PostAction("/userPassword/passwordUpdate", {
          ...this.request
        }).then(res => {
          // 解构res.data
          const { result, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
          } else {
            // 请求失败的场景
            // 请求失败，弹出失败msg的消息提示
            this.$message.error(msg);
          }
          // 关闭loading
          this.loading = false;
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
  }
};
